export default __webpack_public_path__ + "static/incraSooft-a38aba9cd10153eff18b40a4cc22cff5.svg";